import React from 'react'
import styles from './style.module.scss'
import { ListItem, UnorderedList, OrderedList, Box } from '@chakra-ui/react'
import { withGuestLayout } from 'src/components/Layout'
const PrivacyPage = () => {
  const privacyList = [
    {
      title: '取得する利用者情報',
      description:
        '当社は、本サービスにおいて次のようなお客様及び宿泊者に関する情報（以下、「利用者情報」といいます。）を取得及び利用する場合があります。また、利用者情報には、個人情報（個人情報の保護に関する法律の定義によるものとします。以下同じ。）が含まれる場合があります。',
      subDescriptions: [
        'ユーザー登録情報（利用及び宿泊者が本サービスをご利用開始いただく際にご登録いただくメールアドレス、パスワードその他の情報）',
        '本サービスを外部SNSサービス（Facebook、Twitter、Instagramその他の、他の事業者が提供しているソーシャル・ネットワーキングサービスを意味します。）に連携等した場合、当該外部SNSサービス上の宿泊者の情報',
        'お客様及び宿泊者がご利用になった本サービスの内容（予約情報、発信電話番号等を含みますが、これに限られません。）、ご利用日時、ご利用回数、本サービス利用時のご利用内容・履歴・状況に関する情報から得られる情報',
        'お客様及び宿泊者の機器情報',
        'お客様が本サービス上で作成し、又は本サービス上に掲載した写真、コメント、その他の情報',
        'ブラウザの識別等に用いられるクッキー（Cookie）情報',
        'お客様及び宿泊者が本サービスを利用する際に自動的に生成されるアクセスログ',
      ],
    },
    {
      title: '利用者情報の取得について',
      description:
        '当社は、以下のような方法で、利用者情報を取得・収集することがあります。ただし、取得・収集の方法は以下のものに限られません。',
      subDescriptions: [
        '本サービス上で利用者情報をお客様及び宿泊者自身に入力・提供していただく方法',
        '当社に対し、お客様及び宿泊者から電子メール、郵便、書面、電話等で利用者情報をご提供いただく方法',
        'お客様及び宿泊者が本サービスを外部SNSサービスに連携等した場合に、外部SNSサービスから取得する方法',
        'お客様及び宿泊者が本サービスを利用する際に自動的に利用者情報を生成又は収集する方法',
      ],
    },
    {
      title: '利用者情報の管理について',
      description:
        '当社にて利用者情報を管理・利用する業務に従事する者は、利用者情報について厳重に管理を行い、利用者情報への不当なアクセス、紛失、漏洩、改ざん等が起きないよう、利用者情報の取扱いに十分な注意を払い、その業務に努めます。',
    },
    {
      title: '利用者情報の利用目的について',
      description: '当社は、以下の目的のために、利用者情報を利用いたします。',
      subDescriptions: [
        '本サービスの提供・改善・開発のため',
        '本サービスに関する各種事項の連絡や情報提供を行うため',
        '本サービスにユーザー登録する際に必要な情報入力を簡略化するため',
        '電子メール配信サービスのお申し込みの確認やメールを配信するため',
        'ご協力いただいた調査などに対する謝礼等をお送りするため',
        'ご応募いただいた懸賞などに対する景品等をお送りするため',
        '本サービスの利用状況等を調査・分析するため',
        '本サービスの内容をよりご満足いただけるよう改良・改善、又は新サービス開発のため',
        '本サービスの内容を宿泊者に合わせてカスタマイズするため',
        `本サービスに関する満足度を調査するため`,
        '利用者情報を統計的に処理した情報を、集約し調査結果として公表するため',
        'チラシ、ダイレクトメール、電子メール、SMSサービス等での広告・宣伝のため',
        '本サービス、新サービスその他の各種サービスのご案内やお知らせをお届けするため',
        '調査ご協力依頼や各種イベントへのご参加依頼又は、その結果などのご報告のため',
        '本サービス提供上のトラブルの解決のため',
        '本サービスの提供に当たり宿泊者本人からあらかじめ同意を得ている場合に、利用者情報を第三者に提供するため',
        'その他各サービスの提供に当たり利用目的を公表の上、同意をいただいた利用目的のため',
      ],
    },
    {
      title: '利用者情報の第三者への開示について',
      description:
        '当社は、お客様及び宿泊者の個別の同意がある場合を除き、利用者情報を第三者に開示いたしません。但し、以下の場合は例外として、利用者情報を第三者に開示することがあります。その場合にも、提供する利用者情報は必要最低限の情報に限定し、利用者情報が漏洩、滅失、改ざんされないように努めるものとします。',
      subDescriptions: [
        '外部サービスとの連携、外部サービス改善のための情報提供又は、外部サービスを利用した認証にあたり、当該外部サービス運営会社に利用者情報を提供する場合',
        '当社又は第三者の広告の提供のために、必要な範囲で、当該提供を行う第三者に開示する場合。但し、この場合には開示する利用者情報は、個人を識別、特定できないように加工、集計等するものとします。',
        '当社と第三者との紛争解決のため、又は本サービスを利用するお客様及び宿泊者若しくは第三者の権利や利益等を守るために情報開示が必要と当社が判断した場合',
        'その他、法令に基づき、個人情報の第三者への開示が認められる場合',
      ],
      secondDescription:
        'また、当社は、当社の関係会社間で、本サービスの提供を目的として、本規約で定める利用目的のために、利用者情報を共同で利用することがあります。その場合、当社が共同利用する利用者情報の管理の一時的責任を負います。',
    },
    {
      title: 'クッキー（Cookie）について',
      subDescriptions: [
        'クッキー情報に関して、単独では特定の個人を識別することはできません',
        '個人情報が一体となって使用される場合又はクッキー情報が特定の情報に紐づいて個人を識別できる場合には、当該クッキー情報を含む全体の情報を個人情報として取り扱うものとします。',
        '多くのWebブラウザでは、自動的にクッキーの使用が許可されますが、クッキーの使用を禁止するようにブラウザの設定を変更することも可能です。',
        'クッキーの使用を禁止した場合、本サービスを正常にご利用できない、あるいはクッキーを必要とする広告設定を反映できなくなる可能性があります。',
        '当社は、宿泊者のクッキー情報や、閲覧された広告・ページ、宿泊者のご利用環境等の情報を自動的に宿泊者のブラウザから受け取り、サーバーに記録し、本サービスログイン時の電子メールアドレス自動入力等の利便性向上のため、セッションの維持及び保護などセキュリティの為、また、新しいサービスを検討するため、サービスや広告の内容をより宿泊者に適したものとするために利用いたします。',
      ],
    },
    {
      title: 'アクセスログについて',
      description:
        '当社は、宿泊者が本サービス訪問時に自動で生成される、IPアドレス、ブラウザ種類、ブラウザ言語などを取得・収集します。これらの情報はユーザー環境を分析し、より良いサービス提供のため、また正常なサービス提供を妨害する不正行為防止のために利用いたします。検索に関する記録は個人を特定することができない形態で保存及び管理され、統計データ作成などの用途で利用いたします。',
    },
    {
      title: '当社による利用者情報の訂正',
      description:
        '利用者情報のうち、市町村などの名称及び郵便番号、金融機関の名称あるいはクレジットカードの有効期限など、商品のお届けやご請求を行う上で支障がある情報に変更があった場合には、当社が登録されている利用者情報を変更させていただく場合があります。',
    },
    {
      title: '利用者情報の管理及びセキュリティについて',
      description:
        '当社では、利用者情報を、一般のユーザーがアクセスできない環境下にあるサーバーにて安全に保管し、不正アクセス・紛失・破壊・改ざん又は漏洩が生じないよう努めます。',
    },
    {
      title: '匿名加工情報について',
      description:
        '当社は、特定の個人を識別することができないように利用者情報を加工し、当該利用者情報を復元することができないようように匿名加工情報を継続的に作成することがあります。当社が継続的に作成する匿名加工情報については、こちらをご参照ください。',
    },
    {
      title: '免責・注意事項',
      subDescriptions: [
        '当社では、利用者情報を、一般のユーザーがアクセスできない環境下にあるサーバーにて安全に保管し、不正アクセス・紛失・破壊・改ざん又は漏洩が生じないよう努めます。',
        '当社は、本サービスにリンクされている他の事業者又は個人のサービスにおける宿泊者の利用者情報等の保護に関しましては、一切の責任を負いません。宿泊者ご自身にて当該サービスの内容をよくご確認の上で、当該サービスの閲覧及びご利用をお願いいたします。',
        'ハッカー等による不当な行為により、宿泊者及び第三者に損害が生じた場合に関してまして、それが当社の責任による場合を除き ､当社は一切の責任を負いません。',
        'ご本人確認をするための情報につきましては、宿泊者にて、紛失、忘失又は第三者に知られることのないよう厳重な管理をお願いいたします。',
      ],
    },
    {
      title: '海外からのアクセスについて',
      description:
        '本サービスの利用、管理、運用方法及び掲載内容が不適切又は違法とされる国又は地域からの本サービスへのアクセスはご遠慮下さい。',
    },
    {
      title:
        'プライバシーポリシーの改善及び最新のプライバシーポリシーの確認について',
      description:
        '当社は本プライバシーポリシーに関しまして、適宜その改善に取り組みます。お客様及び宿泊者は、本サービスにアクセスされる前及び当社のサービスをご利用になる前に、必ず最新のプライバシーポリシーをご確認ください。お客様及び宿泊者が本サービスにアクセスされた場合又はサービスをご利用になられた場合は、最新のプライバシーポリシーの内容に同意されたものとみなします。',
    },
    {
      title: '個人情報の開示・訂正・利用停止手続について',
      description:
        'お客様及び宿泊者は、個人情報保護法その他関連法令等に従い、個人情報の開示、訂正、利用停止等を求めることができます。開示等の求めを行う場合は、当社指定の「個人情報開示等請求書」に必要事項を記入し、他の必要書類とともに、当社の個人情報相談窓口宛に郵便で送って下さい。 請求書類受取後、社内で審査し、できるだけ速やかにご返答させていただきます。',
    },
  ]
  return (
    <Box className={styles.wholeBox}>
      <Box className={styles.mainBox}>
        <Box className={styles.titleBox}>
          <h1 className={styles.title}>プライバシーポリシー</h1>
        </Box>
        <hr />
        <Box className={styles.textBox}>
          <p className={styles.privacyText}>
            株式会社MOLE（以下、「当社」といいます。）は、個人情報の保護に関する法律その他関連法令等を遵守し、当社の保有するお客様及び宿泊者に関する情報を適正に取り扱うことが企業の重要な社会的責務であるとの認識に立ち、以下のとおりプライバシーポリシーを定めております。
            <br />
            当社では、本プライバシーポリシーに基づき、お客様及び宿泊者の情報を取り扱います。
            <br />
            当社が提供するすべてのサービス（以下、「本サービス」といいます。）には、本プライバシーポリシーが適用されます。そのため、本サービスをご利用いただくためには、本プライバシーポリシーを熟読のうえ、内容に同意していただく必要があります。
            <br />
            同意いただけない場合は、本サービスへのアクセス及び本サービスのご利用はお断りいたします。
            <br />
            なお、サービス別のプライバシーポリシー又は利用規約（以下、併せて「利用規約等」といいます。）において個別に宿泊者に関する情報の取り扱いを規定する場合、本プライバシーポリシーに優先して利用規約等が適用されます。
          </p>
          {privacyList.map((privacy, idx) => (
            <section key={idx}>
              <h2 className={styles.privacyTitle}>{privacy.title}</h2>
              {privacy.description && (
                <p className={styles.privacyText}>{privacy.description}</p>
              )}
              <UnorderedList className={styles.privacyList}>
                {privacy.subDescriptions?.map((subDescription, idx) => (
                  <ListItem className={styles.privacyListText} key={idx}>
                    {subDescription}
                  </ListItem>
                ))}
              </UnorderedList>
              <p className={styles.privacyText}>{privacy.secondDescription}</p>
            </section>
          ))}
          <p className={styles.privacyText}>【必要書類および手数料】</p>
          <OrderedList className={styles.privacyText}>
            <ListItem>当社指定の「個人情報開示等請求書」</ListItem>
            <p className={styles.privacyText}>
              手元にない場合は、ご連絡ください。こちらからお送りいたします。
            </p>
            <ListItem>本人確認書類</ListItem>
            <OrderedList>
              <ListItem className={styles.listStyle}>
                ご本人によるお申し込みの場合
              </ListItem>
              <p>
                不要（後日、ご本人確認のためにご連絡差し上げることがあります。）
              </p>
              <ListItem className={styles.listStyle}>
                代理人によるお申し込みの場合
              </ListItem>
              <p>下記の書類のうち該当するもののすべて。</p>
              <OrderedList listStyleType="lower-alpha">
                <ListItem>親権者（または未成年被後見人)の場合</ListItem>
                <UnorderedList>
                  <ListItem>
                    本人の住所・本籍を確認できる公的証明書のコピー
                  </ListItem>
                  <ListItem>戸籍謄本(全部事項証明)1通のコピー</ListItem>
                  <ListItem>
                    代理人の住所・本籍を確認できる公的証明書のコピー
                  </ListItem>
                </UnorderedList>
                <ListItem>成年後見人(成年被後見人の法定代理人)の場合</ListItem>
                <UnorderedList>
                  <ListItem>人の住所を確認できる公的証明書のコピー</ListItem>
                  <ListItem>
                    「登記事項証明書」1通のコピー(本人の法定代理人であることがわかるもの。)
                  </ListItem>
                  <ListItem>
                    代理人の住所を確認できる公的証明書のコピー
                  </ListItem>
                </UnorderedList>
                <ListItem>委任状による代理人の場合</ListItem>
                <UnorderedList>
                  <ListItem>本人の印鑑証明書のコピー</ListItem>
                  <ListItem>
                    当社指定の委任状(本人の印鑑証明書で使用している印鑑を捺印したもの／当社指定の委任状がお手元にない場合は、ご連絡ください。早急にご郵送します。)
                  </ListItem>
                  <ListItem>
                    代理人の住所を確認できる公的証明書のコピー(弁護士の場合は登録番号でも可)
                    <br />
                    ※「公的証明書」とは、運転免許証、各種健康保険証・年金手帳等、写真付き住民基本台帳カード、旅券(パスポート)、外国人登録証明書、印鑑登録証明書、住民票の写し、戸籍謄本・抄本、外国人登録原票の写し
                    などを言います。
                    <br />
                    ※ご提示いただいた本人確認書類は、以下の通り利用いたします。ご同意いただける方のみご送付下さい。
                  </ListItem>
                  <ListItem>
                    当個人情報は、本人からの開示等の求めに応じるために利用いたします。
                  </ListItem>
                  <ListItem>
                    ご提示いただく本人確認書類によっては、本籍地等特定の機微な個人情報を取得することがあります。
                  </ListItem>
                  <ListItem>
                    法令に基づく場合を除いて、当個人情報を本人の同意なく第三者に提供することはありません。また、当個人情報の取扱いを委託する予定はありません。
                  </ListItem>
                  <ListItem>
                    本人確認書類等により本人確認が出来ない場合、開示等の求めに応じられない場合がございます。
                  </ListItem>
                </UnorderedList>
              </OrderedList>
            </OrderedList>
            <ListItem>手数料</ListItem>
            <p>
              「利用目的の通知」あるいは「開示」につきましては、1件のお申込みにつき手数料として1,000円いただきます。1,000円分の郵便小為替を上記書類にあわせてご同封ください。
              上記の通り手数料が同封されていなかった場合は、その旨ご連絡申し上げますが、所定の期間内にお支払いいただけない場合は開示等の求めがなかったものといたします。なお、送付頂いた書類は原則としてご返却いたしません。
            </p>
          </OrderedList>
          <h2 className={styles.privacyTitle}>お問い合わせ</h2>
          <p className={styles.privacyText}>
            本プライバシーポリシー又は個人情報の取り扱いに関するお問い合わせは、下記までお願いいたします。
          </p>
          <p className={styles.bottomSpace}>株式会社MOLE</p>
          <p className={styles.bottomText}>古田友宏</p>
          <p className={styles.bottomText}>MAIL：info@mole-inc.co</p>
          <p className={styles.bottomText}>TEL：080-9367-5221</p>
          <p className={styles.bottomSpace}> 制定日　2022年4月1日</p>
        </Box>
      </Box>
    </Box>
  )
}
export default withGuestLayout(PrivacyPage)
